// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3k1YGuo99vjDt9edco2T50","content":"_15a03FfGuP2iDfcSK-4GVx","backWrapper":"_1Q6ljPWG0eKkZwCB96ojRr","filterChips":"_1QVQx7d1-epWt2tMtj-eVh","filterChip":"_1pic9skoWzJjbLbvYmDAa","filtersChipWrapper":"_3F7R8vUzowoDv78U9-G0Qr","projectWrapper":"_20WqyoDcyC6tFsO6MBLQBX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignPropertiesListContainer/ForeignPropertiesListContainer.scss
// module id = 1812
// module chunks = 0